<script setup lang="ts">
import { computed } from 'vue';
import { useColors } from '@apparatix/composables';
import { Stack } from '../stack';

type Props = {
  footer?: boolean;
  variant?: 'ai' | 'lite' | 'standard';
}

const props = withDefaults(defineProps<Props>(), {
  footer: true,
  variant: 'standard',
});

// TODO: remove border once flyout design refresh is done
const colors = useColors();

const classes = computed(() => {
  if (props.variant === 'standard' || props.variant === 'lite') {
    return '';
  }
  return 'apx-ai-border';
});
</script>
<template>
  <section
    class="relative flex w-full rounded-lg bg-white shadow-[0px_1px_3px_rgba(0,0,0,0.10)]"
    :class="[classes, props.variant === 'lite' ? '' : 'pt-3 lg:pt-6']"
  >
    <Stack :gap="0">
      <div v-if="props.variant !== 'lite'" class="px-4 lg:px-6">
        <slot name="title" />
      </div>
      <div :class="{'px-4 lg:px-6 pb-3 lg:pb-6': props.variant !== 'lite', 'p-4': props.variant === 'lite'}">
        <slot />
      </div>
      <div
        v-if="props.footer && props.variant !== 'lite'"
        class="flex items-center border-t px-4 py-3 lg:px-6 lg:py-4"
        :style="{ borderTopColor: colors.surface.border.secondary }"
      >
        <slot name="footer" />
      </div>
    </Stack>
  </section>
</template>
